// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__4Yq3o"};